import React, { useState, useEffect } from "react";
import AddIcon from "@material-ui/icons/Add";
import useAssetProvider from "../useAssetProvider";
import { useStyles } from "./Style";
import NewFee from "./NewFee";
import NewAsset from "./NewAsset";
import { Button, Backdrop, Modal, Fade } from "@material-ui/core";

const NewAssetFee = ({ open, setOpen }) => {
	const classes = useStyles();
	const { app, assets, onAssetAdd, onFeeAdd } = useAssetProvider();
	const [isAsset, setIsAsset] = useState(false);
	const [isFee, setIsFee] = useState(false);
	const [transactionType, setTransactionType] = useState("");
	const [amount, setAmount] = useState("");
	const [vendor, setVendor] = useState({});
	const [isDisable, setDisable] = useState(true);

	const feeDetails = {
		name: "Fee-",
		amount: 0,
		application_id: "",
		payable_to: "",
		type: "",
		vendor: "",
		warranty_vendor: "",
		warranty_vendor_other_detail: "",
	};
	const [fee, setFee] = useState(feeDetails);

	const assetObject = {
		name: "A-",
		application_id: "",
		type: "",
		vendor: "",
		vendor_id: "",
		vendor_name: "",
		master_vendor: "",
		description: "",
		price: 0,
		year: "",
		make: "",
		model: "",
		location: "",
		truck_body_description: "N/A",
		truck_body_asset_description: "N/A",
		truck_body_cost: 0,
		truck_body_category: "N/A",
		truck_body_type: "N/A",
		truck_body_year: "N/A",
		truck_body_model: "N/A",
		is_incomplete: true,
		is_trade_in: false,
		is_collateral: false,
		is_cashout: false,
	};
	// const assetTruckWothBodyObject = {
	// 	name: "A-",
	// 	application_id: "",
	// 	type: "",
	// 	vendor: "",
	// 	master_vendor: "",
	// 	description: "Asset Description",
	// 	price: 0,
	// 	year: "2020",
	// 	make: "New Make 2020",
	// 	model: "New Model 2020",
	// 	location: "",
	// 	payoff_amount: 0,
	// 	truck_body_description: "demo body description",
	// 	truck_body_asset_description: " demo body asset description",
	// 	truck_body_cost: 0,
	// 	truck_body_category: "demo body category",
	// 	truck_body_type: "Body",
	// 	truck_body_model: "Body model",
	// };

	const [newAsset, setNewAsset] = useState(assetObject);

	const resetValues = () => {
		if (isAsset) {
			setNewAsset({ ...assetObject, application_id: app.id });
			setVendor({});
			setTransactionType("");
			setAmount("");
		}
		if (isFee)
			setFee({
				...feeDetails,
				vendor: assets[0].vendor,
				application_id: assets[0].application_id,
			});
		setDisable(true);
		return;
	};

	const handleAdd = () => {
		if (isAsset) onAssetAdd(newAsset);
		if (isFee) onFeeAdd(fee);
		resetValues();
		setIsAsset(false);
		setIsFee(false);
		return;
	};

	const handlePlusFee = () => {
		let vendorCount = assets.length;
		for (let item in assets) {
			if (item.vendor !== "") vendorCount--;
		}
		if (vendorCount) alert("All asset must have vendor!");
		else {
			setIsFee(true);
			setIsAsset(false);
		}
		return;
	};

	useEffect(() => {
		if (isAsset) {
			const hasVendor = Boolean(
				newAsset.vendor && String(newAsset.vendor).trim()
			);
			const hasLocation =
				newAsset.location_id !== undefined &&
				newAsset.location_id !== null &&
				newAsset.location_id !== "";
			const hasType = Boolean(newAsset.type);
			if (!transactionType || !hasType || !hasVendor || !hasLocation) {
				setDisable(true);
			} else if (transactionType === "Selling") {
				setDisable(!newAsset.price || newAsset.price <= 0);
			} else if (
				transactionType === "Trade In" ||
				transactionType === "Collateral"
			) {
				const n = parseInt(amount, 10);
				setDisable(!amount || Number.isNaN(n) || n <= 0);
			} else if (transactionType === "Cash Out") {
				setDisable(false);
			} else {
				setDisable(true);
			}
		}
		if (isFee) setDisable(!fee.application_id || !fee.type);
	}, [isAsset, isFee, amount, newAsset, fee, transactionType]);

	useEffect(() => {
		setNewAsset({ ...newAsset, application_id: app.id });
	}, [app]);

	useEffect(() => {
		if (!isAsset) return;
		if (vendor && vendor.id) {
			setNewAsset((prev) => ({
				...prev,
				vendor: vendor?.name || " ",
				vendor_id: vendor?.id || " ",
				vendor_name: vendor?.name || " ",
				vendor_street: vendor.street || "",
				vendor_city: vendor.city || "",
				vendor_zip: vendor.zip_code || "",
				vendor_state: vendor.state || "",
				vendor_country: vendor.country || "",
				phone: vendor.phone || "",
				fax: vendor.fax || "",
			}));
		}
	}, [isAsset, vendor]);

	return (
		<Modal
			className={classes.modal}
			open={open}
			onClose={() => setOpen(false)}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{ timeout: 500 }}>
			<Fade in={open}>
				<div className={classes.paper}>
					{!isAsset && !isFee && (
						<div style={{ textAlign: "center" }}>
							<Button
								size="small"
								className={classes.buttonAction}
								color="primary"
								variant="contained"
								onClick={() => {
									setIsAsset(true);
									setIsFee(false);
								}}>
								<AddIcon />
								Asset
							</Button>
							<Button
								size="small"
								className={classes.buttonAction}
								color="primary"
								variant="contained"
								onClick={() => {
									handlePlusFee();
								}}>
								<AddIcon /> Fee
							</Button>
						</div>
					)}

					{isAsset && (
						<NewAsset
							newAsset={newAsset}
							setNewAsset={setNewAsset}
							setVendor={setVendor}
							transactionType={transactionType}
							setTransactionType={setTransactionType}
							amount={amount}
							setAmount={setAmount}
						/>
					)}

					{isFee && <NewFee fee={fee} setFee={setFee} />}

					{(isAsset || isFee) && (
						<div className={classes.footer}>
							<Button
								size="small"
								style={{ backgroundColor: "black" }}
								className={classes.buttonAction}
								color="primary"
								variant="contained"
								onClick={() => {
									setOpen(false);
									setIsAsset(false);
									setIsFee(false);
								}}>
								Close
							</Button>
							<Button
								size="small"
								style={{ backgroundColor: "#a4020" }}
								className={classes.buttonAction}
								color="secondary"
								variant="contained"
								onClick={() => resetValues()}>
								Reset
							</Button>
							<Button
								size="small"
								style={{ backgroundColor: "#6d94bf" }}
								className={classes.buttonAction}
								color="primary"
								variant="contained"
								disabled={isDisable}
								onClick={() => {
									handleAdd();
									setOpen(false);
								}}>
								Add
							</Button>
						</div>
					)}
				</div>
			</Fade>
		</Modal>
	);
};
export default NewAssetFee;
